import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'bw-portal';

  private readonly translateService: TranslateService = inject(TranslateService);
  private readonly primengConfig: PrimeNGConfig = inject(PrimeNGConfig);

  ngOnInit() {
    this.translateService.get('PRIMENG_LOCALE').subscribe((res: any) => {
      this.primengConfig.setTranslation({ dateFormat: res.dateFormat });
      this.primengConfig.setTranslation({ firstDayOfWeek: res.firstDayOfWeek });
      this.primengConfig.setTranslation({ apply: res.apply });
      this.primengConfig.setTranslation({ clear: res.clear });
      this.primengConfig.setTranslation({ dayNamesMin: res.dayNamesMin });
      this.primengConfig.setTranslation({ dayNamesShort: res.dayNamesShort });
      this.primengConfig.setTranslation({ dayNames: res.dayNames });
      this.primengConfig.setTranslation({ monthNames: res.monthNames });
      this.primengConfig.setTranslation({ monthNamesShort: res.monthNamesShort });
    });
  }
}
